﻿import { EventAsyncGS,EventAsyncGSToken } from "@ivanlog/gs";
import { BiMath } from "../libs/BiMath";
import { App } from "../App";
import { ChainControllerBase } from "../controllers/ChainControllerBase";

export class ShareX {
    public symbol:string;
    public name:string;
    public address:string;
}

export class ShareXInfrastructure
{
    public static ADDRESS_SHAREX_INFO:string = "0x5c57b78e7796337765a1a910DEDb4664425cA66E";

    private _decimals:Map<string, bigint> = new Map<string, bigint>();

    private _onRefresh:EventAsyncGS;
    private _onRefreshToken:EventAsyncGSToken<void>;

    private _sharexs:ShareX[]=[];
    
    private _selectedSharex:ShareX|undefined;

    constructor(){
        this._onRefreshToken = new EventAsyncGSToken<void>();
        this._onRefresh = new EventAsyncGS(this._onRefreshToken);

        this._decimals.set("0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39".toLocaleLowerCase(),BigInt(100000000))
        this._decimals.set("0x57fde0a71132198BBeC939B98976993d8D89D225".toLocaleLowerCase(),BigInt(100000000))
        this._decimals.set("0x3819f64f282bf135d62168C1e513280dAF905e06".toLocaleLowerCase(),BigInt(1000000000))
        this._decimals.set("0xfc4913214444aF5c715cc9F7b52655e788A569ed".toLocaleLowerCase(),BigInt(1000000000))

        const chain = App.Inst.getInst(ChainControllerBase)
        chain.onChangeAccount.addHandler(()=>this.refreshAsync());
    }

    get onRefresh(){return this._onRefresh;}

    get selectedShareX(){return this._selectedSharex;}
    
    public initialize()
    {
        const jsonShareXs = localStorage.getItem("sharex");
        if (!jsonShareXs) return;
        const sharexs = JSON.parse(jsonShareXs);
        for(const sharex of sharexs) this._sharexs.push(sharex);
    }

    public selectShareX(shareX:ShareX)
    {
        this._selectedSharex=shareX;
        this._onRefreshToken.invoke();
    }

    public addSharex(shareX:ShareX)
    {
        if (this.hasSharex(shareX.address)) return;
        this._sharexs.push(shareX);
        this._updateDB();
        this._onRefreshToken.invoke();
    }
    
    public removeSharex(address:string)
    {
        const withoutX = this._sharexs.filter(item => item.address !== address);
        this._sharexs=withoutX;
        this._updateDB();
        this._onRefreshToken.invoke();
    }   
    public hasSharex(address:string)
    {
        const token = this._sharexs.find(item => item.address === address);
        if (token) return true;
        return false;
    }

    public getSharex(address:string)
    {
        const token = this._sharexs.find(item => item.address === address);
        return token;
    }

    public getShareXs()
    {
        return this._sharexs.slice();
    }

    private _updateDB()
    {
        localStorage.setItem("sharex",JSON.stringify(this._sharexs));
    }


    async refreshAsync()
    {
        await this._onRefreshToken.invoke();
    }

    public getDecimal(token:string):bigint
    {
        token=token.toLocaleLowerCase();
        if (this._decimals.has(token)) return this._decimals.get(token);
        return BiMath.Decimal;
    }

    public getDecimalCorIndex(token:string): bigint {
        token=token.toLocaleLowerCase();
        if (!this._decimals.has(token)) return BiMath.Decimal;
        return BiMath.Decimal/this._decimals.get(token)*BiMath.Decimal;
    }
    public getDecimalCorPairIndex(tokenF:string,tokenA:string): bigint {
        let dF = this.getDecimal(tokenF);
        let dA = this.getDecimal(tokenA);
        if (dF==dA) return BiMath.Decimal;
        if (dF<dA) return (dF*BiMath.Decimal)/dA;
        if (dF>dA) return (dF/dA)*BiMath.Decimal;
    }
}